// extracted by mini-css-extract-plugin
module.exports = {"promotionButton":"Promotion_promotionButton__lLHXi","imageWrapper":"Promotion_imageWrapper__wiOHZ","image":"Promotion_image__nbpJW","isActive":"Promotion_isActive__l0slu"};